import {DecoratorNode, $applyNodeReplacement} from 'lexical';
import {SAMPLE_ROOM_ROWS, SEAL_IMAGE} from '../constants';

function RoomView() {
  return (
    <div className="de-room">
      <div className="de-room-label">{'{{room_details}}'} - filled by the backend (sample shown)</div>
      <table>
        <tbody>
          <tr><th>Category</th><th>Rooms</th><th>Rate</th></tr>
          {SAMPLE_ROOM_ROWS.map((r) => (
            <tr key={r[0]}>{r.map((c) => <td key={c}>{c}</td>)}</tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function SealView() {
  return (
    <div className="de-seal">
      <img src={SEAL_IMAGE} alt="seal" />
      <div className="de-room-label">{'{{seal}}'}</div>
    </div>
  );
}

const CONFIG = {
  room_details: {cls: 'room-details'},
  seal: {cls: 'seal'},
};

/** Locked block for {{room_details}} or {{seal}}. Always a standalone <div>, never inside <p>. */
export class BlockTokenNode extends DecoratorNode {
  __token;
  constructor(token = 'room_details', key) {
    super(key);
    this.__token = token;
  }
  static getType() { return 'doc-block-token'; }
  static clone(node) { return new BlockTokenNode(node.__token, node.__key); }
  static importJSON(json) { return $createBlockTokenNode(json.token); }
  exportJSON() { return {type: 'doc-block-token', version: 1, token: this.__token}; }

  createDOM() {
    const el = document.createElement('div');
    el.className = 'de-skip de-block';
    return el;
  }
  updateDOM() { return false; }
  isInline() { return false; }
  isIsolated() { return true; }
  exportDOM() {
    const el = document.createElement('div');
    el.className = CONFIG[this.__token].cls;
    el.textContent = `{{${this.__token}}}`;
    return {element: el};
  }
  static importDOM() {
    return {
      div: (dom) => {
        const hit = Object.keys(CONFIG).find((k) => dom.classList.contains(CONFIG[k].cls));
        return hit
          ? {conversion: () => ({node: $createBlockTokenNode(hit)}), priority: 2}
          : null;
      },
    };
  }
  decorate() { return this.__token === 'seal' ? <SealView /> : <RoomView />; }
}

export const $createBlockTokenNode = (token) => $applyNodeReplacement(new BlockTokenNode(token));
export const $isBlockTokenNode = (n) => n instanceof BlockTokenNode;
